import React, { useEffect } from 'react'
import Campus_Ambassador_discuraption from './Campus_Ambassador_discuraption'
import CA_second_comp from './CA_second_comp'
import CA_third_comp from './CA_third_comp'
import CA_forth_comp from './CA_forth_comp'
import CA_total_Count from './CA_total_count'
import { Helmet } from 'react-helmet-async'
import CA_certification from './CA_certification'

function Campus_Ambassador() {
  const canonicalUrl = 'https://www.internselite.net/Campus-Ambassador-Program'
  return (
    <>
      <Helmet>
        <title>
          Join InternsElite’s Campus Ambassador Program | Empower Your Campus
          with Top IT Skills
        </title>
        <meta
          name="description"
          content="Become a leader in your academic community by joining InternsElite’s Campus Ambassador Program. This unique opportunity allows you to bring cutting-edge IT courses like AI, ML, and Web Development directly to your campus. Enhance your resume with our certification, gain exclusive access to professional training, and connect with industry leaders. Apply now to start your journey as a Campus Ambassador and shape the future of IT skill development among your peers."
        />
        <meta
          name="keywords"
          content="Campus Ambassador Program, IT Skill Development, Student Leadership Opportunities, InternsElite Certification, Online IT Training, Professional Networking"
        />
        <meta
          property="og:title"
          content="Join InternsElite’s Campus Ambassador Program | Empower Your Campus with Top IT Skills"
        />
        <meta
          property="og:description"
          content="Become a leader in your academic community by joining InternsElite’s Campus Ambassador Program. This unique opportunity allows you to bring cutting-edge IT courses like AI, ML, and Web Development directly to your campus. Enhance your resume with our certification, gain exclusive access to professional training, and connect with industry leaders. Apply now to start your journey as a Campus Ambassador and shape the future of IT skill development among your peers."
        />
        <meta
          property="og:url"
          content="https://internselite.net/Campus-Ambassador-Program"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta
          name="twitter:title"
          content="Join InternsElite’s Campus Ambassador Program | Empower Your Campus with Top IT Skills"
        />
        <meta
          name="twitter:description"
          content="Become a leader in your academic community by joining InternsElite’s Campus Ambassador Program. This unique opportunity allows you to bring cutting-edge IT courses like AI, ML, and Web Development directly to your campus. Enhance your resume with our certification, gain exclusive access to professional training, and connect with industry leaders. Apply now to start your journey as a Campus Ambassador and shape the future of IT skill development among your peers."
        />
        <meta
          name="twitter:image"
          content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      {/* ------------------------Mobile View------------------------------ */}
      <div className="CA_background_image d-sm-block d-md-none mt-5">
        <div className="container-fluid CA_background_color pt-4">
          <div className="text-center pt-5 mobile_CA_Main_text">
            <h1 className="display-6 pt-5 text-white">
              InternsElite's Campus Ambassador
            </h1>
            <h3 className="text-white pt-2 pb-5">
              Be the Campus Trendsetter with InternsElite!
            </h3>
          </div>
        </div>
      </div>

      {/* ------------------------Desktop View------------------------------ */}
      <div className="CA_background_image d-none d-md-block mt-5">
        <div className="container-fluid CA_background_color py-5">
          <div className="text-center pt-5 About_Main_text mt-5">
            <h1 className="display-4 pt-5 mt-5 text-white">
              InternsElite's Campus Ambassador
            </h1>
            <h3 className="text-white fs-2 pt-3 mb-5">
              Be the Campus Trendsetter with InternsElite!
            </h3>
          </div>
        </div>
      </div>
      <Campus_Ambassador_discuraption />
      <CA_second_comp />
      <div className="Roadmap_background d-none d-xl-block">
        <div className="container pb-5">
          <CA_third_comp />
        </div>
      </div>
      <CA_certification/>
      <div className="pt-5 pb-4">
        <CA_forth_comp />
      </div>
      <CA_total_Count />
    </>
  )
}

export default Campus_Ambassador
